export default function isOptimisticId(id: string): boolean {
  return id.startsWith("@");
}
